module.exports = __webpack_public_path__ + "img/kiss.abf10dfb.gif";